export const countryContactListArray = [
  {
    id: 1,
    department: 'EMBASSY',
    contactName: 'PEREZ MARTINEZ',
    phone: '+52 2299020825',
    email: 'a.ortizcrr@gmail.com',
  },
];

export const countryContactHeadersArray = [
  { title: 'Department', field: 'deparment' },
  { title: 'Contact Name', field: 'contactName' },
  { title: 'Phone 1', field: 'phone' },
  { title: 'Email 1', field: 'email' },
];

export const firContactHeadersArray = [
  { title: 'Department', field: 'department' },
  { title: 'Contact Name', field: 'name' },
  { title: 'Phone 1', field: 'telephone' },
  { title: 'Email 1', field: 'email' },
];
